//---------	Global imports
import React from 'react';

//---------	Plugins
import ScrollArea from 'react-scrollbar/dist/no-css';

//---------	Translations
import { T } from '../../../translations'

//---------	Styles
import './scrollbar.sass';
import './index.sass';


class Sidebar extends React.Component {
  
  //---------	Constructor
  constructor(props) {
    super();
    
    this.title = props.title;
    this.state = {
      sidebarActive: false
    };
    this.toggleSidebar = this.toggleSidebar.bind(this);
  }
  
  
  //---------	React functions
  componentDidMount() {
    this.props.onRef(this);
  }
  
  componentWillUnmount() {
    this.props.onRef(undefined);
  }
  
  
  //---------	Custom functions
  toggleSidebar() {
    this.setState({sidebarActive: !this.state.sidebarActive});
  }
  
  
  //---------	Render
  render() {
    return (
      <div className={this.state.sidebarActive ? 'CalipsySidebar state-active' : 'CalipsySidebar'}>
        <div className="CalipsySidebar-background" onClick={this.toggleSidebar}></div>
        <div className="CalipsySidebar-wrapper">
          <div className="CalipsySidebar-header">
            <h2 className="CalipsySidebar-title">{ this.title }</h2>
            <button className="CalipsySidebar-close" onClick={this.toggleSidebar}>{ T.global.close }</button>
          </div>
          <ScrollArea
            speed={0.8}
            className="area"
            contentClassName="content"
            horizontal={false}>
            { this.props.children }
          </ScrollArea>
        </div>
      </div>
    );
  }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js